// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../static/img/asset-folder-closed.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.asset-thumbnail-expiry {
  padding-left: 5px;
}

.asset-thumbnail-icon {
  cursor: pointer;
  padding-left: 5px;
  padding-right: 5px;
  color: white;
}

.asset-thumbnail-item {
  margin-bottom: 10px;
  background: #f0f3f4;
}

.asset-thumbnail-item.disabled {
  opacity: 0.6;
}
.asset-thumbnail-item.disabled .asset-thumbnail-image {
  cursor: default;
}

.at-folder-thumbnail-icon {
  background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center center no-repeat;
  cursor: pointer;
  padding-left: 5px;
  padding-right: 5px;
  width: 100%;
  height: 100%;
  padding-top: 15px;
  background-size: 80% 80%;
  background-position-y: bottom;
}

.asset-thumbnail-bottom-bar {
  color: white;
  font-size: 12px;
  height: 22px;
  overflow: hidden;
  padding: 2px;
  display: flex;
  justify-content: space-between;
}

.asset-thumbnail-image-back {
  cursor: pointer;
  text-align: center;
  display: block;
  align-items: center;
  justify-content: center;
}
.asset-thumbnail-image-back .asset-thumbnail-image-title-backdrop {
  position: absolute;
  opacity: 0;
  transition: 300ms;
}
.asset-thumbnail-image-back .asset-thumbnail-image-title-backdrop .asset-thumbnail-image-title {
  color: white;
  background: rgba(0, 0, 0, 0.5);
  padding: 15px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.asset-thumbnail-image-back .asset-thumbnail-image-title-backdrop:hover {
  opacity: 1;
  transition: 300ms;
}
.asset-thumbnail-image-back .asset-thumbnail-fallback {
  min-width: 0;
}
.asset-thumbnail-image-back .asset-thumbnail-fallback .asset-thumbnail-fallback-title {
  padding: 5px;
  color: #555;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.asset-thumbnail-image-back .asset-thumbnail-fallback .asset-thumbnail-fallback-icon {
  padding: 5px;
}
.asset-thumbnail-image-back .asset-thumbnail-fallback .asset-thumbnail-fallback-size {
  padding: 5px;
  color: #555;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: bottom;
}

.asset-thumbnail-item.selected {
  transform: scale(1.02, 1.02);
  transition: 100ms;
}

.asset-thumbnail-item.deselected {
  opacity: 0.6;
  transform: scale(0.95, 0.95);
  transition: 100ms;
}

.no-text-highlight {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */ /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */ /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
             supported by Chrome, Opera and Firefox */
}`, "",{"version":3,"sources":["webpack://./../../libraries/components/dist/src/AssetLibrary/AssetThumbnailViewItem/AssetThumbnailViewItem.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;AACJ;;AAEA;EACI,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;AACJ;;AAEA;EACI,mBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,YAAA;AACJ;AACI;EACI,eAAA;AACR;;AAGA;EACI,uFAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,wBAAA;EACA,6BAAA;AAAJ;;AAGA;EACI,YAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;AAAJ;;AAGA;EACI,eAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;AAAJ;AAEI;EACI,kBAAA;EACA,UAAA;EACA,iBAAA;AAAR;AAEQ;EACI,YAAA;EACA,8BAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAAZ;AAII;EACI,UAAA;EACA,iBAAA;AAFR;AAKI;EACI,YAAA;AAHR;AAKQ;EACI,YAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAHZ;AAMQ;EACI,YAAA;AAJZ;AAOQ;EACI,YAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AALZ;;AAUA;EACI,4BAAA;EACA,iBAAA;AAPJ;;AAUA;EACI,YAAA;EACA,4BAAA;EACA,iBAAA;AAPJ;;AAUA;EACI,2BAAA,EAAA,eAAA;EACA,yBAAA,EAAA,WAAA,EACA,mBAAA;EACA,sBAAA,EAAA,4BAAA,EACA,2BAAA;EACA,iBAAA,EAAA;qDAAA;AANJ","sourcesContent":[".asset-thumbnail-expiry {\n    padding-left: 5px;\n}\n\n.asset-thumbnail-icon {\n    cursor: pointer;\n    padding-left: 5px;\n    padding-right: 5px;\n    color: white;\n}\n\n.asset-thumbnail-item {\n    margin-bottom: 10px;\n    background: #f0f3f4;\n}\n\n.asset-thumbnail-item.disabled {\n    opacity: 0.6;\n\n    .asset-thumbnail-image {\n        cursor: default;\n    }\n}\n\n.at-folder-thumbnail-icon {\n    background: transparent url('../../../static/img/asset-folder-closed.svg') center center no-repeat;\n    cursor: pointer;\n    padding-left: 5px;\n    padding-right: 5px;\n    width: 100%;\n    height: 100%;\n    padding-top: 15px;\n    background-size: 80% 80%;\n    background-position-y: bottom;\n}\n\n.asset-thumbnail-bottom-bar {\n    color: white;\n    font-size: 12px;\n    height: 22px;\n    overflow: hidden;\n    padding: 2px;\n    display: flex;\n    justify-content: space-between;\n}\n\n.asset-thumbnail-image-back {\n    cursor: pointer;\n    text-align: center;\n    display: block;\n    align-items: center;\n    justify-content: center;\n\n    .asset-thumbnail-image-title-backdrop {\n        position: absolute;\n        opacity: 0;\n        transition: 300ms;\n\n        .asset-thumbnail-image-title {\n            color: white;\n            background: rgba(0, 0, 0, 0.5);\n            padding: 15px;\n            overflow: hidden;\n            white-space: nowrap;\n            text-overflow: ellipsis;\n        }\n    }\n\n    .asset-thumbnail-image-title-backdrop:hover {\n        opacity: 1;\n        transition: 300ms;\n    }\n\n    .asset-thumbnail-fallback {\n        min-width: 0; // The default min-width sets width of child to be greater than the outer flexbox in some cases.\n\n        .asset-thumbnail-fallback-title {\n            padding: 5px;\n            color: #555;\n            overflow: hidden;\n            white-space: nowrap;\n            text-overflow: ellipsis;\n        }\n\n        .asset-thumbnail-fallback-icon {\n            padding: 5px;\n        }\n\n        .asset-thumbnail-fallback-size {\n            padding: 5px;\n            color: #555;\n            overflow: hidden;\n            white-space: nowrap;\n            text-overflow: ellipsis;\n            vertical-align: bottom;\n        }\n    }\n}\n\n.asset-thumbnail-item.selected {\n    transform: scale(1.02, 1.02);\n    transition: 100ms;\n}\n\n.asset-thumbnail-item.deselected {\n    opacity: 0.6;\n    transform: scale(0.95, 0.95);\n    transition: 100ms;\n}\n\n.no-text-highlight {\n    -webkit-touch-callout: none; /* iOS Safari */\n    -webkit-user-select: none; /* Safari */\n    -khtml-user-select: none; /* Konqueror HTML */\n    -moz-user-select: none; /* Old versions of Firefox */\n    -ms-user-select: none; /* Internet Explorer/Edge */\n    user-select: none; /* Non-prefixed version, currently\n                                    supported by Chrome, Opera and Firefox */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
